import PaymentIcon from "@assets/icons/PaymentIcon";
import Loader from "@components/Loader/Loader";
import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const BankInfo = ({
  paymentInfo,
  paymentTerms,
  setPaymentTerms,
  note,
  setNote,
  isLoadingBankData,
}) => {
  const { t } = useTranslation();
  return (
    <div className="invoice-section">
      <Stack
        className="bank-info"
        sx={{
          backgroundColor: "#f8fbff",
          padding: "1.5rem",
          borderRadius: "16px",
        }}
      >
        <div className="invoice-column">
          <div>
            <PaymentIcon />
            <h3>{t("invoice.payment_info")}</h3>
          </div>
          {isLoadingBankData ? (
            <Loader />
          ) : (
            <div className="invoice-field">
              <div>
                {t("invoice.bank_name") || "Nom"} : {paymentInfo.bankName}
              </div>
              <div>IBAN : {paymentInfo.iban}</div>
              <div>BIC : {paymentInfo.bic}</div>
              <div>RIB : {paymentInfo.rib}</div>
            </div>
          )}
        </div>

        <div className="invoice-column">
          <h3>{t("invoice.payment_terms")}</h3>
          <div className="invoice-field">
            <textarea
              value={paymentTerms}
              onChange={(e) => setPaymentTerms(e.target.value)}
              className="terms-textarea"
            />
          </div>
        </div>

        <div className="invoice-column">
          <h3>{t("invoice.note")}</h3>
          <div className="invoice-field">
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="notes-textarea"
            />
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default BankInfo;
